import GoBack from '@/components/common/go-back/GoBack';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';
import { Skeleton } from '@/components/ui/skeleton';
import ErrorMessage from '@/components/common/error-message/ErrorMessage';
import useGetSaleByConsumer from '@/hooks/queries/sales-api/useGetSalesByConsumer';
import useGetConsumerById from '@/hooks/queries/consumer-api/useGetConsumerById';
import { UserInfo } from './components/user-info/UserInfo';
import { ParticipantsInfo } from '../../Sales/SaleDetail/components/participants-info/ParticipantsInfo';
import { UserSales } from './components/user-sales/UserSales';
import FormUploadConsumerImage from '@/components/forms/form-uploadConsumer-image/FormUploadConsumerImage';
import { Button } from '@/components/ui/button';

const UserDetail = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const {
    data: sales,
    isLoading: isLoadingSalesConsumer,
    isError: isErrorSalesConsumer
  } = useGetSaleByConsumer(id ?? '');
  const {
    data: user,
    isLoading: isLoadingConsumer,
    isError: isErrorConsumer
  } = useGetConsumerById(id);

  if (isLoadingSalesConsumer || isLoadingConsumer) {
    return (
      <>
        <GoBack />
        <Skeleton className="w-full h-4/5" />
      </>
    );
  }

  if (isErrorSalesConsumer || isErrorConsumer) {
    return (
      <>
        <GoBack />
        <ErrorMessage />
      </>
    );
  }

  const participants = sales?.map((sale) => sale.participants).flat() || [];
  const uniqueParticipants = Array.from(
    new Map(participants.map((p) => [p.id, p])).values()
  );

  return (
    <>
      <GoBack />
      <div className="flex flex-col w-full gap-4">
        <Card className="p-0 rounded-md">
          <CardHeader className="flex flex-row items-center justify-between">
            <CardTitle className="text-xl">
              {t('clients.titles.client')}
            </CardTitle>
            <Button variant="secondary">
              <Link to={`/users/${user?.id}/edit`}>
                {t('clients.buttons.edit')}
              </Link>
            </Button>
          </CardHeader>
          <CardContent>
            <UserInfo user={user} />
          </CardContent>
        </Card>
        <Card className="p-0 rounded-md">
          <CardHeader>
            <CardTitle className="text-xl">
              {t('clients.titles.participants')}
            </CardTitle>
          </CardHeader>
          <CardContent>
            <ParticipantsInfo participants={uniqueParticipants} />
          </CardContent>
        </Card>
        <Card className="p-0 rounded-md">
          <CardHeader>
            <CardTitle className="text-xl">
              {t('clients.titles.sales')}
            </CardTitle>
          </CardHeader>
          <CardContent>
            <UserSales sales={sales || []} isLoading={isLoadingSalesConsumer} />
          </CardContent>
        </Card>
        {user?.id ? (
          <FormUploadConsumerImage id={user.id} />
        ) : (
          <Skeleton className="w-full h-10" />
        )}
      </div>
    </>
  );
};

export default UserDetail;
